<div class="zero-image" *ngIf="svgIcon" [innerHtml]="svgIcon | safe: 'html'"> </div>
<mat-icon class="zero-image" *ngIf="!svgIcon && !localIcon">{{defaultIcon}}</mat-icon>
<!-- <mat-icon class="zero-image" *ngIf="!svgIcon && localIcon">{{localIcon}}</mat-icon> -->
<mat-icon class="zero-image" *ngIf="!svgIcon && localIcon" svgIcon="{{localIcon}}"> </mat-icon>
